/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboard',
        subtitle: 'Unique dashboard designs',
        type: 'aside',
        icon: 'heroicons_outline:home',
        link: '/home'
     }, 
     {
        id: 'reportCustomers',
        title: 'Clienti',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/report-customers'
    }, 
    {
        id: 'reportSuppliers',
        title: 'Fornitori',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/report-suppliers'
    }, 
    
    {
        id: 'reportSales',
        title: 'Vendite',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/report-sales'
    }, 
    
    {
        id: 'reportContracts',
        title: 'Contratti',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/report-contracts'
    }, 
     {
        id: 'reportContractCompetitor',
        title: 'Competitor',
        type: 'aside',
        icon: 'heroicons_outline:fire',
        link: '/report-contractCompetitor'
    }, 
     {
        id: 'archive',
        title: 'Documenti',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/archive'
    }, 
    {
        id: 'crm',
        title: 'CRM',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/crm'
    }, 
    {
        id: 'activities',
        title: 'Attività',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/activities'
    }, 
    {
        id: 'commissions',
        title: 'Provvigioni',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/commissions'
    }, 
    {
        id: 'imports',
        title: 'Imports',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/imports'
    }, 
    {
        id: 'configurations',
        title: 'Configurazione',       
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'companies',
                title: 'Aziende',
                type: 'basic',
                 link: '/companies'
            },
            {
                id: 'customers',
                title: 'Clienti',
                type: 'basic',
                 link: '/customers'
            },
             {
                id: 'customer-destination',
                title: 'Destinazioni clienti',
                type: 'basic',
                link: '/customer-destination'
            },
            {
                id: 'suppliers',
                title: 'Fornitori',
                type: 'basic',
                 link: '/suppliers'
            },
            {
                id: 'products',
                title: 'Prodotti',
                type: 'basic',
                 link: '/products'
            },
             {
                id: 'categories',
                title: 'Linee di prodotti',
                type: 'basic',
                 link: '/categoriesSuppliers'
            },
             {
                id: 'agents',
                title: 'Agenti',
                type: 'basic',
                 link: '/agents'
            },
             {
                id: 'users',
                title: 'Utenti',
                type: 'basic',
                 link: '/users'
            },
        ],
    },
    {
        id: 'divider-1',
        type: 'divider',
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboard',
        subtitle: 'Unique dashboard designs',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home'
     }, 
     {
        id: 'customersReport',
        title: 'Clienti',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/example'
    }, 
    {
        id: 'suppliersReport',
        title: 'Fornitori',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/suppliersReport'
    }, 
     
    {
        id: 'salesReport',
        title: 'Vendite',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/salesReport'
    }, 
    
    {
        id: 'contracts',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/contracts'
    }, 
    {
        id: 'contractCompetitor',
        title: 'Competitor',
        type: 'basic',
        icon: 'heroicons_outline:fire',
        link: '/contractCompetitor'
    }, 
     {
        id: 'archive',
        title: 'Documenti',
        type: 'basic',
        icon: 'heroicons_outline:folder-open',
        link: '/archive'
    }, 
    {
        id: 'crm',
        title: 'CRM',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/crm'
    }, 
    {
        id: 'activities',
        title: 'Attività',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/activities'
    }, 
    {
        id: 'commissions',
        title: 'Provvigioni',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/commissions'
    }, 
    {
        id: 'imports',
        title: 'Imports',
        type: 'basic',
        icon: 'heroicons_outline:arrow-up-tray',
        link: '/imports'
    }, 
    {
        id: 'configurations',
        title: 'Configurazione',
        type: 'aside',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/example',
        children: [],
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'heroicons_outline:squares-2x2',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
